import React from 'react';
import { CollectionsProvider } from '@fiverr-private/collect_actions';
import { HighlightsData } from '../../types';
import { PAGE_NAME } from '../../../../configuration/constants';

export interface RolePageContextProps {
    highlightsData: HighlightsData | object;
}

const initialContext: RolePageContextProps = {
    highlightsData: {
        collaborateData: {},
        matchingIndustriesData: {},
    },
};

export const RolePageContext = React.createContext<RolePageContextProps>(initialContext);

export const RolePageContextProvider: React.FC<React.PropsWithChildren<RolePageContextProps>> = ({
    highlightsData,
    children,
}) => (
    <CollectionsProvider bi={{ source: PAGE_NAME }}>
        <RolePageContext.Provider value={{ highlightsData }}>{children}</RolePageContext.Provider>
    </CollectionsProvider>
);
